 <!--
  2019-2-14, AJK, created file
  2019-2-20, AJK, updated to check for match between old and new password
  2019-3-06, AJK, updated to use snotify 
 -->


<template>
  <div class="users container" style="padding-left:0px; padding-right:0px;">
    <div class="cardBox">
      <div class="column is-one-half">
        <!-- INPUTS -->
        <b-field autocomplete="off" label="Company or Name" expanded :type="!address.name ? 'is-danger': ''">
          <b-input v-model="address.name"/>
        </b-field>
        <b-field autocomplete="off" label="Address Line 1" expanded :type="!address.shippingAddressLine1 ? 'is-danger': ''">
          <b-input v-model="address.shippingAddressLine1"/>
        </b-field>
        <b-field label="Address Line 2" expanded>
          <b-input v-model="address.shippingAddressLine2"/>
        </b-field>

        <b-field grouped>
          <b-field label="Address City" expanded :type="!address.shippingAddressCity ? 'is-danger': ''">
            <b-input v-model="address.shippingAddressCity"/>
          </b-field>
          <b-field label="Address State" expanded :type="!address.shippingAddressState ? 'is-danger': ''">
            <b-input v-model="address.shippingAddressState"/>
          </b-field>
          <b-field label="Address Zip" expanded :type="!address.shippingAddressZip ? 'is-danger': ''">
            <b-input v-model="address.shippingAddressZip"/>
          </b-field>
        </b-field>

        <b-field label="Address Country" expanded>
          <b-input v-model="address.shippingAddressCountry"/>
        </b-field>

        <b-field expanded v-if="isFromCheckout">
          <b-checkbox v-model="address.isDefault" style="margin-top:10px;font-weight: 700;">Default Shipping Address</b-checkbox>
        </b-field>
        <!-- BUTTON -->
        <div class="newccbutton">
          <button type="button" @click="update()" :style="{ 'background-color': buttonColor(cantUpdate || requireAddress) }" class="updateButton button is-primary">{{$props.isUpdate ? 'Update': 'Save'}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import { mapMutations, mapState, mapGetters  } from 'vuex'
import store from '../store.js'
import axios from "axios";


export default {
  components:{
  },
  name: 'Shipping',
  props: {
    isNew: Boolean,
    isUpdate: Boolean,
    isFromCheckout: Boolean,
    AddressID: String,
    Address: Object
  },
  data () {
    return {
      address: {
        isDefault: null,
        shippingAddressLine1: null,
        shippingAddressLine2: null,
        shippingAddressCity: null,
        shippingAddressState: null,
        shippingAddressZip: null,
        shippingAddressCountry: null,
        name: null,
      },
    }
  },

  watch:{
    Address() {
      this.loadPage()
    }
  },
  
  computed: {
  ...mapState([
      'cart', 'userInfo'
    ]),

    cantUpdate: function() {
      if (
        this.$props.isUpdate &&
        this.address.name == this.$props.Address.name &&
        this.address.shippingAddressLine1 == this.$props.Address.shippingLine1 &&
        this.address.shippingAddressLine2 == this.$props.Address.shippingLine2 &&
        this.address.shippingAddressCity == this.$props.Address.shippingCity &&
        this.address.shippingAddressState == this.$props.Address.shippingState &&
        this.address.shippingAddressZip == this.$props.Address.shippingZip &&
        this.address.shippingAddressCountry == this.$props.Address.shippingCountry &&
        this.address.isDefault == this.$props.Address.isDefault
      ) {
        return true
      }
      else{
        return false
      }
    },

    requireAddress: function() {
      if (
        !this.address.shippingAddressLine1 ||
        !this.address.shippingAddressCity ||
        !this.address.shippingAddressState ||
        !this.address.shippingAddressZip
      ) {
          return true
      }
      else{
          return false
      }
    },
  },


  mounted() {
    this.loadPage()
  },
  
  methods:{ 
    ...mapMutations([
    ]),

    loadPage(){
        this.address.name = this.$props.Address.name
        this.address.shippingAddressLine1 = this.$props.Address.shippingLine1
        this.address.shippingAddressLine2 = this.$props.Address.shippingLine2
        this.address.shippingAddressCity = this.$props.Address.shippingCity
        this.address.shippingAddressState = this.$props.Address.shippingState
        this.address.shippingAddressZip = this.$props.Address.shippingZip
        this.address.shippingAddressCountry = this.$props.Address.shippingCountry
        this.address.isDefault = this.$props.Address.isDefault
    },

    async update() {
      if(this.cantUpdate){
        this.$root.$children[0].$refs.toast.error('No fields have been updated', "Error")
        return
      }

      if(this.requireAddress){
        this.$root.$children[0].$refs.toast.error('Please enter all required fields.', "Error")
        return
      }

      try{
        //populdate parameters
        var scriptParameters = {
          address: this.address,
          isNew: this.$props.isNew,
          isUpdate: this.$props.isUpdate,
          AddressID: this.$props.AddressID,
          wholesalerID: this.userInfo.userID
        }
        var params = JSON.stringify(scriptParameters)

        //runs script to update or create new address
        const result = await sharedAPI.runScript("Wholesale - Web Log - Update Address", params )
        console.log(result)

        //ensure DAPI encountered no errors
        if (result.messages[0].code != 0){
          throw result.messages[0].message
        }

        //ensure script ran with no errors
        var scriptResult = JSON.parse(result.response.scriptResult)
        if (scriptResult.code != 0){
          throw scriptResult.error
        }

        //emits completion.
        this.$emit('update', scriptResult.result)

        //log success
        this.$root.$children[0].$refs.toast.success("Successfully updated", "Success")
      }
      catch(e){
        console.log(e)
        this.$root.$children[0].$refs.toast.error(e, "Error")
      }
    },

    buttonColor: function(param){
      if(param == true){
        return 'grey'
      }else{
        return ''
      }
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.cardBox{
  min-width: 500px;
  width:100%;
  padding: 5px;
  background-color: white;
}

.updateButton{
  margin-top: 10px;
  width: 100%
}

</style>